module.exports = __webpack_public_path__ + "static/media/filterBy.bdd01d8d.svg";